// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trafico-recoger-no-scroll {
  overflow-y: hidden;
  overflow-x: hidden;
}

.trafico-recoger-page {
  height: 100dvh;
  min-height: 100dvh;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  overflow-x: hidden;
  background: #f5f7fb;
}

.trafico-recoger-content {
  width: 100%;
  max-width: 100%;
  height: calc(100dvh - 78px);
  min-width: 0;
  overflow: hidden;
}

/* El fullscreen se aplica a toda la vista para conservar buscador, lista, mapa e InfoWindow. */

.trafico-recoger-content:fullscreen .trafico-recoger-map-layout,
.trafico-recoger-content:-webkit-full-screen .trafico-recoger-map-layout,
.trafico-recoger-content.is-map-fullscreen .trafico-recoger-map-layout {
  flex: 1 1 auto;
  min-height: 0;
}

.trafico-recoger-heading,
.trafico-recoger-actions,
.trafico-recoger-view-switch,
.trafico-recoger-toolbar label,
.trafico-recoger-actions > label {
  display: flex;
  align-items: center;
}

.trafico-recoger-heading {
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.trafico-recoger-heading h1 {
  margin: 0;
  color: #173961;
  font-size: 24px;
  font-weight: 700;
}

.trafico-recoger-heading p {
  margin: 5px 0 0;
  color: #71839b;
  font-size: 13px;
}

.trafico-recoger-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.trafico-recoger-actions > label {
  width: min(390px, 34vw);
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #d7e1ec;
  border-radius: 8px;
  background: #fff;
  color: #7c8fa6;
}

.trafico-recoger-filter-select {
  width: min(190px, 18vw);
  min-width: 160px;
}

.trafico-recoger-filter__control {
  min-height: 38px !important;
  border-color: #d7e1ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  cursor: pointer !important;
}

.trafico-recoger-filter__control:hover,
.trafico-recoger-filter__control--is-focused {
  border-color: #87a9c4 !important;
}

.trafico-recoger-page {
  --solicitudes-filter-red: #f39a97;
}

.trafico-recoger-filter__menu {
  z-index: 20000 !important;
}

.trafico-recoger-filter__menu-portal {
  z-index: 20000 !important;
}

.trafico-recoger-filter__option {
  font-size: 12px;
}

.trafico-recoger-filter-option-label,
.trafico-recoger-filter-placeholder {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.trafico-recoger-filter-option-label {
  justify-content: space-between;
  width: 100%;
}

.trafico-recoger-filter-option-label > span:first-child {
  min-width: 0;
  overflow-wrap: anywhere;
}

.trafico-recoger-delay-summary {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  color: #71839b;
  font-size: 13px;
  white-space: nowrap;
}

.trafico-recoger-delay-summary > span:first-child {
  margin-right: 2px;
}

.trafico-recoger-filter-count-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  box-sizing: border-box;
  padding: 0 6px;
  border-radius: 999px;
  background: #e4eef7;
  color: #305274;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.trafico-recoger-filter-count-badge.is-delay-yellow {
  background: #fff0b8;
  color: #806500;
}

.trafico-recoger-filter-count-badge.is-delay-normal {
  border: 1px solid #d7e1ec;
  background: #fff;
  color: #71839b;
}

.trafico-recoger-filter-count-badge.is-delay-orange {
  background: rgba(224, 160, 25, 0.24);
  color: #8a5b00;
}

.trafico-recoger-filter-count-badge.is-delay-red {
  background: var(--solicitudes-filter-red) !important;
  color: #fff !important;
  opacity: 1 !important;
}

.trafico-recoger-filter__option .trafico-recoger-filter-count-badge.is-delay-red,
.trafico-recoger-filter__option--is-focused .trafico-recoger-filter-count-badge.is-delay-red,
.trafico-recoger-filter__option--is-selected .trafico-recoger-filter-count-badge.is-delay-red {
  display: inline-flex !important;
  flex: 0 0 22px !important;
  width: 22px !important;
  height: 20px !important;
  min-width: 22px !important;
  padding: 0 6px !important;
  border-radius: 999px !important;
  background-color: #f39a97 !important;
  color: #6f1f1b !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.trafico-recoger-refresh,
.trafico-recoger-view-switch button {
  min-height: 38px;
  border: 1px solid #d7e1ec;
  background: #fff;
  color: #305274;
  cursor: pointer;
  font-weight: 600;
}

.trafico-recoger-refresh {
  border-radius: 8px;
  padding: 0 13px;
}

.trafico-recoger-refresh i {
  margin-right: 5px;
}

.trafico-recoger-refresh:disabled {
  cursor: wait;
  opacity: 0.6;
}

.trafico-recoger-view-switch {
  overflow: hidden;
  border-radius: 8px;
}

.trafico-recoger-view-switch button {
  border-width: 1px 0 1px 1px;
  padding: 0 13px;
}

.trafico-recoger-view-switch button:last-child {
  border-right-width: 1px;
}

.trafico-recoger-view-switch button.is-active {
  background: #006699;
  border-color: #006699;
  color: #fff;
}

.trafico-recoger-toolbar {
  margin-bottom: 14px;
}

.trafico-recoger-toolbar label {
  width: min(100%, 520px);
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #d7e1ec;
  border-radius: 8px;
  background: #fff;
  color: #7c8fa6;
}

.trafico-recoger-toolbar input {
  width: 100%;
  height: 40px;
  border: 0;
  outline: 0;
  color: #243b53;
}

.trafico-recoger-actions > label input {
  width: 100%;
  height: 38px;
  border: 0;
  outline: 0;
  color: #243b53;
}

.trafico-recoger-table-card,
.trafico-recoger-map-card {
  overflow: hidden;
  border: 1px solid #e1e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(32, 65, 97, 0.05);
}

.trafico-recoger-mobile-list {
  display: none;
}

.trafico-recoger-table-scroll {
  height: calc(100dvh - 220px);
  overflow-x: hidden;
  overflow-y: auto;
}

.trafico-recoger-table {
  margin: 0;
  color: #364f6b;
  font-size: 12px;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}

/* Distribución fija para mantener todos los campos visibles sin scroll horizontal. */
.trafico-recoger-table th:nth-child(1),
.trafico-recoger-table td:nth-child(1) {
  width: 13% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(2),
.trafico-recoger-table td:nth-child(2) {
  width: 8% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(3),
.trafico-recoger-table td:nth-child(3) {
  width: 11% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(4),
.trafico-recoger-table td:nth-child(4) {
  width: 17% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(5),
.trafico-recoger-table td:nth-child(5) {
  width: 19% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(6),
.trafico-recoger-table td:nth-child(6) {
  width: 10% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(7),
.trafico-recoger-table td:nth-child(7) {
  width: 9% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(8),
.trafico-recoger-table td:nth-child(8) {
  width: 7% !important;
  min-width: 0 !important;
}

.trafico-recoger-table th:nth-child(9),
.trafico-recoger-table td:nth-child(9) {
  width: 6% !important;
  min-width: 64px !important;
  text-align: center;
}

.trafico-recoger-table th:nth-child(1),
.trafico-recoger-table td:nth-child(1) {
  left: 0 !important;
}

.trafico-recoger-table th:nth-child(2),
.trafico-recoger-table td:nth-child(2) {
  left: auto !important;
}

/* Esta tabla no necesita columnas congeladas; evita el espacio visual entre Empresa y Agencia. */
.trafico-recoger-table tbody td:nth-child(-n + 2) {
  position: static !important;
  left: auto !important;
  box-shadow: none !important;
}

.trafico-recoger-table th {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #006699;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: clip;
  line-height: 1.15;
  font-size: 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-align: center;
  vertical-align: middle;
}

.trafico-recoger-table thead th,
.trafico-recoger-table thead th * {
  color: #fff !important;
}

.trafico-recoger-sort-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-transform: inherit;
}

.trafico-recoger-sort-button i {
  flex: 0 0 auto;
  font-size: 13px;
  opacity: 0.7;
}

.trafico-recoger-sort-button.is-active i {
  opacity: 1;
}

.trafico-recoger-sort-button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
  border-radius: 4px;
}

.trafico-recoger-table td {
  padding: 5px;
  vertical-align: middle;
  max-width: 0;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.35;
}

.trafico-recoger-table strong {
  color: #000;
}

.trafico-recoger-table tbody td {
  color: #000;
}

/* El contenedor usa text-nowrap por compatibilidad con otras tablas, pero
 * la novedad debe ocupar varias líneas dentro de su propia columna. */
.trafico-recoger-table tbody td:nth-child(5),
.trafico-recoger-table thead th:nth-child(5) {
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.trafico-recoger-table tbody tr {
  background: #fff;
  cursor: default;
}

.trafico-recoger-novelty-trigger {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.trafico-recoger-novelty-trigger:hover,
.trafico-recoger-novelty-trigger:focus-visible {
  color: #1769aa;
  text-decoration: underline;
}

.trafico-recoger-refuerzo-badge {
  margin-left: 4px;
  vertical-align: middle;
}

.trafico-recoger-table tbody tr.is-selected,
.trafico-recoger-table tbody tr:hover {
  background: #edf7ff;
}

.trafico-recoger-table tbody tr.is-delay-yellow {
  background: #fff8d8;
}

.trafico-recoger-table tbody tr.is-delay-orange {
  background: rgba(224, 160, 25, 0.16);
}

.trafico-recoger-table tbody tr.is-delay-red {
  background: var(--solicitudes-filter-red);
}

.trafico-recoger-table tbody tr.is-delay-yellow:hover,
.trafico-recoger-table tbody tr.is-delay-yellow.is-selected {
  background: #fff0b8;
}

.trafico-recoger-table tbody tr.is-delay-orange:hover,
.trafico-recoger-table tbody tr.is-delay-orange.is-selected {
  background: rgba(224, 160, 25, 0.28);
}

.trafico-recoger-table tbody tr.is-delay-red:hover,
.trafico-recoger-table tbody tr.is-delay-red.is-selected {
  background: var(--solicitudes-filter-red);
}

/* Bootstrap aplica el fondo directamente sobre los td en desktop; por eso
 * el estado de retraso también debe pintar cada celda de la fila. */
.trafico-recoger-table tbody tr.is-delay-yellow > td {
  background-color: #fff8d8 !important;
}

.trafico-recoger-table tbody tr.is-delay-orange > td {
  background-color: color-mix(in srgb, #e0a019 16%, white) !important;
}

.trafico-recoger-table tbody tr.is-delay-red > td {
  background-color: var(--solicitudes-filter-red) !important;
  color: #6f1f1b !important;
}

.trafico-recoger-table tbody tr.is-delay-yellow:hover > td,
.trafico-recoger-table tbody tr.is-delay-yellow.is-selected > td {
  background-color: #fff0b8 !important;
}

.trafico-recoger-table tbody tr.is-delay-orange:hover > td,
.trafico-recoger-table tbody tr.is-delay-orange.is-selected > td {
  background-color: color-mix(in srgb, #e0a019 28%, white) !important;
}

.trafico-recoger-table tbody tr.is-delay-red:hover > td,
.trafico-recoger-table tbody tr.is-delay-red.is-selected > td {
  background-color: var(--solicitudes-filter-red) !important;
}

.trafico-recoger-table tbody tr.is-delay-red > td strong {
  color: #6f1f1b !important;
}

.trafico-recoger-actions-cell {
  display: table-cell !important;
  vertical-align: middle;
  white-space: nowrap !important;
  text-align: center;
  position: relative !important;
  z-index: 1 !important;
}

.trafico-recoger-actions-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
}

.trafico-recoger-page .custom-tooltip {
  z-index: 20000;
}

.trafico-recoger-page .custom-tooltip::after {
  z-index: 20001;
}

.trafico-recoger-copy-button,
.trafico-recoger-contract-copy-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #cbd8e5;
  border-radius: 6px;
  background: #fff;
  color: #35627f;
  cursor: pointer;
  font-size: 17px;
  line-height: 1;
}

.trafico-recoger-copy-button:hover,
.trafico-recoger-contract-copy-button:hover {
  border-color: #006699;
  background: #edf7ff;
  color: #006699;
}

.trafico-recoger-available-button {
  color: #006699;
}

.trafico-recoger-available-button:hover {
  border-color: #006699;
  background: #edf7ff;
  color: #005580;
}

/* La clase histórica de columnas congeladas eleva la fila al interactuar
 * con un tooltip. En esta vista las acciones deben permanecer dentro de su
 * fila y nunca cubrir el encabezado sticky. */
.trafico-recoger-table thead th {
  z-index: 20 !important;
}

.trafico-recoger-table tbody tr:has(.custom-tooltip:hover),
.trafico-recoger-table tbody tr:has(.custom-tooltip:focus-within) {
  z-index: 1 !important;
}

/* Ajustes propios de la pantalla; el navbar y el drawer los controla
 * traficoResponsive.css mediante body.trafico-responsive-page. */
@media (max-width: 1199px) {
  .trafico-recoger-page .content-wrapper,
  .trafico-recoger-page .container-fluid {
    min-width: 0;
  }
}

.trafico-recoger-empty,
.trafico-recoger-state {
  padding: 42px 20px;
  text-align: center;
  color: #71839b;
}

.trafico-recoger-state-error {
  color: #b42318;
}

.trafico-recoger-map-card {
  width: 100%;
  max-width: 100%;
  height: calc(100dvh - 210px);
  padding: 12px;
}

.trafico-recoger-map {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  border-radius: 9px;
  background: #e9f0f6;
}

.trafico-recoger-map-layout {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  height: 100%;
  border-radius: 9px;
}

.trafico-recoger-map-fullscreen-button {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(215, 225, 236, 0.95);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #305274;
  box-shadow: 0 3px 10px rgba(28, 58, 86, 0.18);
  cursor: pointer;
  font-size: 21px;
}

.trafico-recoger-map-fullscreen-button:hover,
.trafico-recoger-map-fullscreen-button:focus-visible {
  background: #006699;
  color: #fff;
  outline: none;
}

.trafico-recoger-contract-list {
  position: absolute;
  top: 60px;
  left: 10px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  width: 270px;
  min-width: 0;
  max-width: calc(100% - 20px);
  height: calc(100% - 90px);
  max-height: calc(100% - 90px);
  overflow: hidden;
  border: 1px solid #d3deea;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(28, 58, 86, 0.2);
  transition: width 220ms ease, height 260ms ease;
}

.trafico-recoger-map-type-controls {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 6;
  display: flex;
  align-items: stretch;
  width: 270px;
  min-width: 0;
  max-width: calc(100% - 20px);
  height: 40px;
  padding: 0;
  background: #fff;
  border: 1px solid rgba(215, 225, 236, 0.95);
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(28, 58, 86, 0.16);
  overflow: hidden;
}

.trafico-recoger-map-type-controls button {
  flex: 0 0 auto;
  min-width: 0;
  height: 100%;
  padding: 0 14px;
  border: 0;
  border-right: 1px solid #e2e8ee;
  background: #fff;
  color: #526d8f;
  cursor: pointer;
  font: 13px Arial, sans-serif;
  white-space: nowrap;
}

.trafico-recoger-map-type-controls button:first-child {
  flex: 0 0 78px;
  width: 78px;
  border-radius: 2px 0 0 2px;
}

.trafico-recoger-map-type-controls button:nth-child(2) {
  flex: 0 0 96px;
  width: 96px;
}

.trafico-recoger-map-type-controls button:last-child {
  flex: 0 0 96px;
  width: 96px;
  padding-right: 4px;
  padding-left: 4px;
  border-right: 0;
  border-radius: 0 2px 2px 0;
  font-size: 12px;
}

.trafico-recoger-map-type-controls button.is-active {
  position: relative;
  z-index: 1;
  background: #f7f9fb;
  color: #173961;
  font-weight: 700;
}

.trafico-recoger-contract-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 45px;
  padding: 12px 14px;
  width: 100%;
  height: 45px;
  min-height: 45px;
  box-sizing: border-box;
  border: 0;
  background: #006699;
  color: #fff;
  cursor: pointer;
  font: inherit;
  overflow: hidden;
  text-align: left;
}

.trafico-recoger-contract-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 auto;
  min-width: 0;
}

.trafico-recoger-contract-list-header strong,
.trafico-recoger-contract-list-header span {
  color: #fff;
  font-size: 14px;
}

.trafico-recoger-contract-list-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  margin-left: 8px;
  padding: 0;
  box-sizing: border-box;
  border: 0;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
}

.trafico-recoger-contract-list-toggle:hover {
  background: rgba(255, 255, 255, 0.28);
}

.trafico-recoger-contract-list-scroll {
  display: grid;
  flex: 1 1 auto;
  gap: 8px;
  min-height: 0;
  overflow-y: auto;
  padding: 8px;
  background: #f7f9fb;
  transition: max-height 260ms ease, opacity 180ms ease, padding 260ms ease;
  max-height: 1200px;
}

.trafico-recoger-contract-item {
  display: grid;
  gap: 6px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #dbe5ee;
  border-left: 6px solid #a7bed2;
  border-radius: 8px;
  background: #fff;
  color: #000;
  cursor: pointer;
  font: inherit;
  text-align: left;
  box-shadow: 0 2px 8px rgba(28, 58, 86, 0.12);
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.trafico-recoger-contract-item.is-delay-yellow {
  border-left-color: #e2b93b;
  background: #fff8d8;
}

.trafico-recoger-contract-item.is-delay-orange {
  border-left-color: #e0a019;
  background: rgba(224, 160, 25, 0.16);
}

.trafico-recoger-contract-item.is-delay-red {
  border-left-color: var(--solicitudes-filter-red);
  background: var(--solicitudes-filter-red);
  color: #6f1f1b;
}

.trafico-recoger-contract-item:hover,
.trafico-recoger-contract-item.is-selected {
  border-left-color: #006699;
  background: #edf7ff;
}

.trafico-recoger-contract-item.is-delay-red:hover,
.trafico-recoger-contract-item.is-delay-red.is-selected {
  border-left-color: var(--solicitudes-filter-red);
  background: var(--solicitudes-filter-red);
  color: #6f1f1b;
}

.trafico-recoger-contract-item.is-delay-yellow,
.trafico-recoger-contract-item.is-delay-orange,
.trafico-recoger-contract-item.is-delay-red {
  border-top-color: rgba(255, 255, 255, 0.8);
  border-right-color: rgba(255, 255, 255, 0.8);
  border-bottom-color: rgba(255, 255, 255, 0.8);
}

.trafico-recoger-contract-item.is-delay-yellow:hover,
.trafico-recoger-contract-item.is-delay-orange:hover,
.trafico-recoger-contract-item.is-delay-red:hover {
  box-shadow: 0 4px 12px rgba(28, 58, 86, 0.2);
}

.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-title > strong,
.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-plate,
.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-row,
.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-row b,
.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-speed,
.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-footer {
  color: #6f1f1b !important;
}

.trafico-recoger-contract-item-heading,
.trafico-recoger-contract-item-row,
.trafico-recoger-contract-item-footer {
  display: grid;
  min-width: 0;
}

.trafico-recoger-contract-item-heading {
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px;
  min-width: 0;
}

.trafico-recoger-contract-item-heading-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  overflow: visible;
}

.trafico-recoger-contract-copy-button {
  width: 26px;
  height: 26px;
  border: 0;
  background: #edf3f8;
  color: #58758f;
  font-size: 15px;
}

.trafico-recoger-contract-copy-button:hover {
  background: #dcecf7;
}

.trafico-recoger-contract-item-title {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.trafico-recoger-contract-item-title > strong {
  color: #193856;
  font-size: 12px;
  text-transform: uppercase;
}

.trafico-recoger-contract-item-plate {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 999px;
  background: #edf3f8;
  color: #5d7893 !important;
  font-size: 12px !important;
  font-weight: 700;
}

.trafico-recoger-contract-item-plate i {
  color: #476985;
  font-size: 14px;
}

.trafico-recoger-contract-item-chevron {
  color: #58758f;
  font-size: 32px;
  line-height: 1;
}

.trafico-recoger-contract-item-row {
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.trafico-recoger-contract-item-row > i,
.trafico-recoger-contract-item-speed > i {
  color: #4e6e89;
  font-size: 16px;
  text-align: center;
}

.trafico-recoger-contract-item-row > span {
  overflow: hidden;
  color: #45627d;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trafico-recoger-contract-item-row > span b {
  color: #34516d;
}

.trafico-recoger-contract-item-speed {
  display: flex;
  align-items: center;
  gap: 5px;
  border-top: 1px solid #e2eaf1;
  padding-top: 6px;
  color: #4e6e89;
  font-size: 12px;
  font-weight: 700;
}

.trafico-recoger-contract-item-footer {
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border-top: 1px solid #edf1f5;
  padding-top: 6px;
}

.trafico-recoger-contract-item-icons {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #36a852;
  font-size: 18px;
}

.trafico-recoger-contract-item-time-values {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.trafico-recoger-contract-item-last-report {
  overflow: hidden;
  color: #66809a;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.trafico-recoger-uninstall-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
  min-height: 24px;
  padding: 4px 8px;
  border: 1px solid rgba(81, 111, 137, .16);
  border-radius: 999px;
  background: #edf3f8;
  color: #45627d;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
}

.trafico-recoger-uninstall-badge i {
  font-size: 13px;
}

.trafico-recoger-uninstall-badge strong {
  font-size: 10px;
}

.trafico-recoger-uninstall-badge.is-delay-yellow {
  border-color: #ead58a;
  background: #fff0b8;
  color: #806500;
}

.trafico-recoger-uninstall-badge.is-delay-orange {
  border-color: #e0a019;
  background: #f3c28f;
  color: #754b00;
}

.trafico-recoger-uninstall-badge.is-delay-red {
  border-color: #e02b29;
  background: #f39a97;
  color: #6f1f1b;
}

.trafico-recoger-contract-item.is-delay-red .trafico-recoger-uninstall-badge {
  border-color: rgba(111, 31, 27, .28);
}

.trafico-recoger-contract-item-heading > strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trafico-recoger-contract-list-empty {
  margin: 12px 6px;
  color: #71839b;
  font-size: 12px;
  text-align: center;
}

.trafico-recoger-contract-list.is-collapsed {
  width: 160px;
  min-width: 160px;
  height: 45px;
  max-height: 45px;
}

.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-header {
  height: 45px;
  min-height: 45px;
  flex-basis: 45px;
  justify-content: center;
  padding: 8px;
}

.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-scroll {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
}

.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-toggle {
  margin-left: 0;
}

.trafico-recoger-map-summary {
  margin: 10px 2px 0;
  color: #71839b;
  font-size: 12px;
}

.trafico-recoger-map-info {
  display: grid;
  gap: 3px;
  width: min(330px, 72vw);
  max-width: 330px;
  min-width: 220px;
  margin: 0 auto;
  max-height: none;
  overflow: visible;
  padding: 2px;
  color: #304a65;
  font-size: 12px;
}

/* Google Maps crea un scroll propio en el contenedor del InfoWindow. Para
   este popup se desactiva y se conserva únicamente el scroll del historial. */
.gm-style-iw-c:has(.trafico-recoger-map-info),
.gm-style-iw-d:has(.trafico-recoger-map-info),
.gm-style-iw:has(.trafico-recoger-map-info) {
  max-height: none !important;
  overflow: visible !important;
}

.gm-style-iw-c:has(.trafico-recoger-map-info) {
  width: min(370px, calc(100vw - 40px)) !important;
  max-width: calc(100vw - 40px) !important;
  box-sizing: border-box !important;
  padding: 14px !important;
}

.gm-style-iw-d:has(.trafico-recoger-map-info) {
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 0 !important;
}

.trafico-recoger-map-info {
  width: 100%;
  max-width: none;
  min-width: 0;
  margin: 0;
  box-sizing: border-box;
}

.trafico-recoger-map-info strong {
  color: #173961;
}

.trafico-recoger-map-info-heading {
  margin-top: 6px;
  border-top: 1px solid #dbe5ee;
  padding-top: 6px;
}

.trafico-recoger-map-info-chat {
  display: grid;
  gap: 6px;
  max-height: 190px;
  overflow-y: auto;
  padding-right: 3px;
}

.trafico-recoger-map-info-message {
  padding: 6px 7px;
  border-left: 3px solid #006699;
  border-radius: 5px;
  background: #f3f7fa;
}

.trafico-recoger-map-info-message-meta {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3px;
}

.trafico-recoger-map-info-message-meta strong {
  color: #34516d;
  font-size: 11px;
}

.trafico-recoger-map-info-message-meta time {
  color: #71839b;
  font-size: 10px;
  white-space: nowrap;
}

.trafico-recoger-map-info-message p {
  margin: 0;
  color: #243b53;
  font-size: 11px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.trafico-recoger-map-info-form {
  display: grid;
  gap: 5px;
  margin-top: 7px;
  border-top: 1px solid #dbe5ee;
  padding-top: 7px;
}

.trafico-recoger-map-info-form textarea {
  width: 100%;
  resize: vertical;
  border: 1px solid #cbd8e5;
  border-radius: 5px;
  padding: 5px 7px;
  color: #243b53;
  font: inherit;
  font-size: 11px;
  outline: 0;
}

.trafico-recoger-map-info-form textarea:focus {
  border-color: #006699;
  box-shadow: 0 0 0 2px rgba(0, 102, 153, 0.12);
}

.trafico-recoger-map-info-form-actions {
  display: flex;
  justify-content: center;
}

.trafico-recoger-map-info-form button {
  min-height: 26px;
  border: 0;
  border-radius: 5px;
  padding: 0 10px;
  background: #006699;
  color: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
}

.trafico-recoger-map-info-form button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.trafico-recoger-novedades-modal {
  max-width: 420px;
}

.trafico-recoger-novedades-modal .modal-content {
  overflow: hidden;
  border: 1px solid #d7e1ec;
  border-radius: 10px;
}

.trafico-recoger-novedades-modal .modal-header {
  position: relative !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  padding: 12px 16px;
  background: #006699;
  color: #fff;
  overflow: visible !important;
  pointer-events: auto !important;
}

.trafico-recoger-novedades-modal .modal-title,
.trafico-recoger-novedades-modal .modal-header .btn-close {
  color: #fff;
}

.trafico-recoger-novedades-modal .modal-title {
  margin: 0 !important;
  padding: 0 !important;
  color: #fff !important;
  font-size: 20px;
  line-height: 1.25;
}

.trafico-recoger-novedades-modal .modal-header .btn-close {
  position: static !important;
  display: grid !important;
  flex: 0 0 32px;
  width: 32px !important;
  height: 32px !important;
  margin: 0 0 0 auto !important;
  padding: 0;
  border: 1px solid #d0dbe8;
  border-radius: 50%;
  background-color: #edf2f8;
  background-size: 14px;
  filter: none;
  opacity: 1;
}

.trafico-recoger-novedades-modal .modal-header .btn-close:hover,
.trafico-recoger-novedades-modal .modal-header .btn-close:focus {
  background-color: #fff;
  opacity: 1;
}

/* ModalBaseSm aplica esta clase al dialog; estas reglas ganan a los estilos
   generales de ResponsiveModalSheets en pantallas pequeñas. */
.modal .trafico-recoger-novedades-modal > .modal-content > .modal-header {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  pointer-events: auto !important;
  overflow: visible !important;
}

.modal .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {
  position: static !important;
  inset: auto !important;
  align-self: center !important;
  transform: none !important;
  top: auto !important;
  right: auto !important;
  display: grid !important;
  flex: 0 0 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 0 0 auto !important;
  padding: 0 !important;
  border: 1px solid #d0dbe8 !important;
  border-radius: 50% !important;
  background-color: #edf2f8 !important;
  filter: none !important;
  opacity: 1 !important;
}

.trafico-recoger-novedades-modal .modal-body {
  max-height: min(80dvh, 650px);
  overflow: hidden;
  padding: 14px 16px 16px;
  color: #243b53;
}

.trafico-recoger-novedades-content {
  display: grid;
  gap: 12px;
}

.trafico-recoger-novedades-list {
  display: grid;
  gap: 8px;
  max-height: min(320px, 45dvh);
  overflow-y: auto;
  padding-right: 4px;
}

.trafico-recoger-novedad {
  padding: 9px 10px;
  border: 1px solid #dbe5ee;
  border-left: 4px solid #006699;
  border-radius: 7px;
  background: #f7f9fb;
}

.trafico-recoger-novedad-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 5px;
}

.trafico-recoger-novedad-meta strong {
  color: #34516d;
  font-size: 12px;
}

.trafico-recoger-novedad p {
  margin: 0;
  color: #243b53;
  font-size: 13px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.trafico-recoger-novedad time {
  display: block;
  color: #71839b;
  font-size: 11px;
  white-space: nowrap;
}

.trafico-recoger-novedades-message,
.trafico-recoger-novedades-error {
  margin: 0;
  font-size: 13px;
}

.trafico-recoger-novedades-message {
  color: #71839b;
}

.trafico-recoger-novedades-error {
  color: #b42318;
}

.trafico-recoger-novedades-sync-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #1769aa;
  font-size: 13px;
  font-weight: 600;
}

.trafico-recoger-novedad-form {
  display: grid;
  gap: 7px;
  border-top: 1px solid #e1e8f0;
  padding-top: 12px;
}

.trafico-recoger-novedad-form label {
  color: #243b53;
  font-size: 13px;
  font-weight: 700;
}

.trafico-recoger-novedad-form textarea {
  width: 100%;
  resize: vertical;
  border: 1px solid #cbd8e5;
  border-radius: 6px;
  padding: 8px 10px;
  color: #243b53;
  font: inherit;
  font-size: 13px;
  outline: 0;
}

.trafico-recoger-novedad-form textarea:focus {
  border-color: #006699;
  box-shadow: 0 0 0 2px rgba(0, 102, 153, 0.12);
}

.trafico-recoger-novedad-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.trafico-recoger-novedad-form button {
  min-height: 34px;
  border: 0;
  border-radius: 6px;
  padding: 0 13px;
  background: #006699;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.trafico-recoger-novedad-form .trafico-recoger-novedad-cancel {
  border: 1px solid #cbd8e5;
  background: #fff;
  color: #45627d;
}

.trafico-recoger-novedad-form .trafico-recoger-novedad-cancel:hover:not(:disabled) {
  background: #f3f7fa;
}

.trafico-recoger-novedad-form button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 768px) {
  body.trafico-recoger-no-scroll {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .trafico-recoger-page,
  .trafico-recoger-content {
    height: auto;
    min-height: 100dvh;
    overflow: visible;
  }

  .trafico-recoger-page {
    padding-bottom: calc(70px + env(safe-area-inset-bottom));
  }

  .trafico-recoger-content {
    min-height: calc(100dvh - 70px);
    padding-bottom: calc(86px + env(safe-area-inset-bottom)) !important;
  }

  .trafico-recoger-table-scroll {
    height: auto;
    width: 100% !important;
    max-width: 100%;
  }

  /* En móvil se usa la tarjeta responsive, como en la vista Tráfico. */
  .trafico-recoger-page .trafico-recoger-table-card {
    display: none !important;
  }

  .trafico-recoger-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 8px;
  }

  .trafico-recoger-mobile-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 16px;
    border: 1px solid #dce6ef;
    border-left: 5px solid #9bb8ce;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(37, 61, 86, 0.08);
    color: #304f6e;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(37, 61, 86, 0.12);
    transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
  }

  .trafico-recoger-mobile-card.is-selected,
  .trafico-recoger-mobile-card:active {
    border-left-color: #006699;
    background: #edf7ff;
  }

  .trafico-recoger-mobile-card.is-delay-yellow {
    border-color: #ead58a;
    background: #fff8d8;
  }

  .trafico-recoger-mobile-card.is-delay-orange {
    border-color: #e0a019;
    background: rgba(224, 160, 25, 0.16);
  }

  .trafico-recoger-mobile-card.is-delay-red {
    border-color: var(--solicitudes-filter-red);
    background: var(--solicitudes-filter-red);
    color: #6f1f1b;
  }

  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-header strong,
  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-header span,
  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-label,
  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-novelty span,
  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-time-label,
  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-time-metric strong {
    color: #6f1f1b !important;
  }

  .trafico-recoger-mobile-card-header,
  .trafico-recoger-mobile-card-footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
  }

  .trafico-recoger-mobile-card-header > div:first-child {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 3px;
  }

  .trafico-recoger-mobile-card-header strong {
    color: #173961;
    font-size: 15px;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .trafico-recoger-mobile-card-header span,
  .trafico-recoger-mobile-card-footer {
    color: #71839b;
    font-size: 13px;
  }

  .trafico-recoger-mobile-card-actions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 6px;
  }

  .trafico-recoger-mobile-card-actions .trafico-recoger-copy-button {
    width: 36px;
    height: 36px;
  }

  .trafico-recoger-mobile-card-device,
  .trafico-recoger-mobile-card-footer span {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .trafico-recoger-mobile-card-device {
    padding: 9px 10px;
    border-radius: 9px;
    background: #eef5fa;
    color: #456b89;
    font-size: 14px;
  }

  .trafico-recoger-mobile-card-device i,
  .trafico-recoger-mobile-card-footer i {
    color: #006699;
    font-size: 18px;
  }

  .trafico-recoger-mobile-time-metric {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 8px;
  }

  .trafico-recoger-mobile-time-metric > div {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 2px;
  }

  .trafico-recoger-mobile-time-metric > i {
    flex: 0 0 auto;
    color: #006699;
    font-size: 19px;
  }

  .trafico-recoger-mobile-time-label {
    display: block !important;
    color: #71839b;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .03em;
    line-height: 1.15;
    text-transform: uppercase;
  }

  .trafico-recoger-mobile-time-metric strong {
    display: block;
    color: #304f6e;
    font-size: 13px;
    line-height: 1.2;
    overflow-wrap: anywhere;
  }

  .trafico-recoger-mobile-card-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.8fr);
    gap: 12px;
  }

  .trafico-recoger-mobile-card-grid > div,
  .trafico-recoger-mobile-card-novelty {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 3px;
    font-size: 13px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .trafico-recoger-mobile-label {
    color: #71839b;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .trafico-recoger-mobile-card-novelty {
    padding-top: 10px;
    border-top: 1px solid #e0e9f1;
  }

  button.trafico-recoger-mobile-card-novelty {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
  }

  button.trafico-recoger-mobile-card-novelty:hover,
  button.trafico-recoger-mobile-card-novelty:focus-visible {
    color: #1769aa;
  }

  .trafico-recoger-mobile-card-footer {
    padding-top: 10px;
    border-top: 1px solid #e0e9f1;
  }

  .trafico-recoger-mobile-card-footer > i {
    font-size: 22px;
  }

  .trafico-recoger-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .trafico-recoger-actions {
    justify-content: flex-start;
    gap: 8px;
    width: 100%;
    margin-bottom: 20px;
  }

  .trafico-recoger-actions > label {
    box-sizing: border-box;
    min-height: 52px;
    width: 100%;
    order: -1;
    border-color: #dce5ef;
    border-radius: 14px;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);
    padding: 0 14px;
  }

  .trafico-recoger-actions > label i {
    font-size: 20px;
  }

  .trafico-recoger-actions > label input {
    height: 50px;
    min-width: 0;
    font-size: 16px;
  }

  .trafico-recoger-actions > label input::placeholder {
    color: #9aabbc;
  }

  .trafico-recoger-filter-select {
    width: 100%;
    min-width: 0;
  }

  .trafico-recoger-filter__control {
    height: 52px !important;
    min-height: 52px !important;
    border-color: #dce5ef !important;
    border-radius: 14px !important;
    background: #fff;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06) !important;
  }

  .trafico-recoger-filter__value-container,
  .trafico-recoger-filter__indicators {
    min-height: 50px;
  }

  .trafico-recoger-filter__placeholder {
    color: #9aabbc;
    font-size: 16px;
  }

  .trafico-recoger-refresh,
  .trafico-recoger-view-switch button {
    min-height: 52px;
    border-radius: 14px;
  }

  .trafico-recoger-table thead {
    display: none;
  }

  .trafico-recoger-table,
  .trafico-recoger-table tbody,
  .trafico-recoger-table tr,
  .trafico-recoger-table td {
    display: block;
    width: 100%;
    min-width: 0 !important;
  }

  .trafico-recoger-table tbody tr {
    padding: 12px 14px;
    border-bottom: 1px solid #e8eef4;
  }

  .trafico-recoger-table td {
    position: static !important;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 5px 0;
    white-space: normal;
    text-align: right;
  }

  .trafico-recoger-table td.trafico-recoger-actions-cell {
    display: table-cell !important;
    justify-content: center;
  }

  .trafico-recoger-table td.trafico-recoger-actions-cell::before {
    display: none;
  }

  .trafico-recoger-table td::before {
    color: #71839b;
    content: attr(data-label);
    font-weight: 600;
    text-align: left;
  }

  .trafico-recoger-map {
    height: 55dvh;
    min-height: 55dvh;
  }

  .trafico-recoger-map-card {
    width: 100%;
    height: auto;
    margin-bottom: 12px;
  }

  .trafico-recoger-table-card {
    margin-bottom: 12px;
  }

  .trafico-recoger-map-layout {
    height: 55dvh;
    overflow: hidden;
  }

  .trafico-recoger-map-fullscreen-button {
    top: 10px;
    right: 10px;
  }

  .trafico-recoger-map-type-controls {
    left: 10px;
    width: min(270px, calc(100% - 20px));
    min-width: 0;
    max-width: calc(100% - 20px);
  }

  .trafico-recoger-contract-list {
    top: auto;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    min-width: 0;
    height: 220px;
    border-radius: 10px 10px 0 0;
  }

  .trafico-recoger-contract-list.is-collapsed {
    width: 100%;
    min-width: 0;
    height: 48px;
    max-height: 48px;
  }

  .trafico-recoger-contract-list-scroll {
    height: auto;
  }
}

/* El modal de novedades usa ModalBaseSm + ResponsiveModalSheets. En móvil
 * se mantiene el bottom sheet parcial, el header global con handle/X y un
 * solo scroll para la lista del chat; el formulario queda siempre visible. */
@media (max-width: 767px) {
  .trafico-recoger-novedades-modal > .modal-content {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .trafico-recoger-novedades-modal > .modal-content > .modal-header {
    position: sticky !important;
    top: 0;
    flex: 0 0 auto;
    flex-direction: column !important;
    align-items: stretch !important;
    min-height: 26px;
    padding: 8px 0 10px !important;
    background: #006699;
    color: #fff;
    pointer-events: none !important;
  }

  .trafico-recoger-novedades-modal > .modal-content > .modal-header .modal-title {
    display: block !important;
    padding: 8px 56px 10px 18px;
    color: #fff !important;
    font-size: 18px;
    text-align: left;
  }

  body.trafico-recoger-page .modal:not(.responsive-modal-sheet-expanded)
    .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {
    display: none !important;
  }

  body.trafico-recoger-page .modal.responsive-modal-sheet-expanded
    .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    display: grid !important;
    margin: 0 !important;
    pointer-events: auto !important;
  }

  .trafico-recoger-novedades-modal > .modal-content > .modal-body {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    max-height: none;
    overflow: hidden;
    padding: 10px 14px 14px;
  }

  .trafico-recoger-novedades-content {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    gap: 10px;
  }

  .trafico-recoger-novedades-list {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-right: 3px;
  }

  .trafico-recoger-novedad-form {
    flex: 0 0 auto;
  }

  .trafico-recoger-novedad-form textarea {
    min-height: 76px;
  }

  .trafico-recoger-novedad-actions {
    justify-content: flex-end;
  }
}

/* El modal debe quedar por encima de las acciones de las tarjetas. Los
 * tooltips de esta página tienen z-index alto para la grilla y el mapa, por
 * eso el bottom sheet necesita una capa propia mientras está abierto. */
body .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal) {
  z-index: 30000 !important;
}

body.modal-open .trafico-recoger-page .custom-tooltip {
  z-index: 1 !important;
}

body.modal-open .trafico-recoger-page .custom-tooltip::after {
  z-index: 2 !important;
}

@media (max-width: 767px) {
  body .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal)
    > .modal-dialog.trafico-recoger-novedades-modal
    > .modal-content
    > .modal-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    min-height: 26px !important;
    padding: 8px 0 10px !important;
    background: #006699 !important;
    color: #fff !important;
    pointer-events: none !important;
  }

  body .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal)
    > .modal-dialog.trafico-recoger-novedades-modal
    > .modal-content
    > .modal-header
    > .modal-title {
    display: block !important;
    padding: 8px 56px 10px 18px !important;
    color: #fff !important;
    font-size: 18px !important;
    line-height: 1.25;
  }

  body .modal.show:not(.responsive-modal-sheet-expanded):has(> .modal-dialog.trafico-recoger-novedades-modal)
    .modal-header .btn-close {
    display: none !important;
  }

  body .modal.show.responsive-modal-sheet-expanded:has(> .modal-dialog.trafico-recoger-novedades-modal)
    .modal-header .btn-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    display: grid !important;
    margin: 0 !important;
    pointer-events: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/traficoPorRecoger.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,+FAA+F;;AAsB/F;;;EAGE,cAAc;EACd,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,qFAAqF;AACrF;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,iGAAiG;AACjG;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;sEACsE;AACtE;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;oEACoE;AACpE;EACE,oCAAoC;AACtC;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,0DAA0D;EAC1D,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,mEAAmE;AACrE;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;8CAE8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;iEACiE;AACjE;EACE;;IAEE,YAAY;EACd;AACF;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yEAAyE;EACzE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,uFAAuF;AACzF;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,gDAAgD;EAChD,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;8EAC8E;AAC9E;;;EAGE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;8DAC8D;AAC9D;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,+BAA+B;IAC/B,mEAAmE;EACrE;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;EACjB;;EAEA,qEAAqE;EACrE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,cAAc;IACd,eAAe;IACf,6CAA6C;IAC7C,uFAAuF;EACzF;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,2CAA2C;IAC3C,yCAAyC;IACzC,cAAc;EAChB;;EAEA;;;;;;IAME,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,yDAAyD;IACzD,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sDAAsD;IACtD,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,QAAQ;IACR,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,6CAA6C;IAC7C,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;IAChB,wDAAwD;EAC1D;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;IACV,oCAAoC;IACpC,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;6EAE6E;AAC7E;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,MAAM;IACN,cAAc;IACd,iCAAiC;IACjC,+BAA+B;IAC/B,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;wEAEwE;AACxE;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;;IAIE,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;;;;;IAKE,yBAAyB;IACzB,sCAAsC;IACtC,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,oBAAoB;IACpB,+BAA+B;EACjC;AACF","sourcesContent":[".trafico-recoger-no-scroll {\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n\n.trafico-recoger-page {\n  height: 100dvh;\n  min-height: 100dvh;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  overflow-x: hidden;\n  background: #f5f7fb;\n}\n\n.trafico-recoger-content {\n  width: 100%;\n  max-width: 100%;\n  height: calc(100dvh - 78px);\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* El fullscreen se aplica a toda la vista para conservar buscador, lista, mapa e InfoWindow. */\n.trafico-recoger-content:fullscreen,\n.trafico-recoger-content:-webkit-full-screen,\n.trafico-recoger-content.is-map-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100dvh;\n  min-height: 100dvh;\n  box-sizing: border-box;\n  padding: 18px 24px 20px;\n  overflow: hidden;\n  background: #f5f7fb;\n}\n\n.trafico-recoger-content:fullscreen .trafico-recoger-map-card,\n.trafico-recoger-content:-webkit-full-screen .trafico-recoger-map-card,\n.trafico-recoger-content.is-map-fullscreen .trafico-recoger-map-card {\n  display: flex;\n  flex-direction: column;\n  height: calc(100dvh - 132px);\n}\n\n.trafico-recoger-content:fullscreen .trafico-recoger-map-layout,\n.trafico-recoger-content:-webkit-full-screen .trafico-recoger-map-layout,\n.trafico-recoger-content.is-map-fullscreen .trafico-recoger-map-layout {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.trafico-recoger-heading,\n.trafico-recoger-actions,\n.trafico-recoger-view-switch,\n.trafico-recoger-toolbar label,\n.trafico-recoger-actions > label {\n  display: flex;\n  align-items: center;\n}\n\n.trafico-recoger-heading {\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n\n.trafico-recoger-heading h1 {\n  margin: 0;\n  color: #173961;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.trafico-recoger-heading p {\n  margin: 5px 0 0;\n  color: #71839b;\n  font-size: 13px;\n}\n\n.trafico-recoger-actions {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.trafico-recoger-actions > label {\n  width: min(390px, 34vw);\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #d7e1ec;\n  border-radius: 8px;\n  background: #fff;\n  color: #7c8fa6;\n}\n\n.trafico-recoger-filter-select {\n  width: min(190px, 18vw);\n  min-width: 160px;\n}\n\n.trafico-recoger-filter__control {\n  min-height: 38px !important;\n  border-color: #d7e1ec !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n  cursor: pointer !important;\n}\n\n.trafico-recoger-filter__control:hover,\n.trafico-recoger-filter__control--is-focused {\n  border-color: #87a9c4 !important;\n}\n\n.trafico-recoger-page {\n  --solicitudes-filter-red: #f39a97;\n}\n\n.trafico-recoger-filter__menu {\n  z-index: 20000 !important;\n}\n\n.trafico-recoger-filter__menu-portal {\n  z-index: 20000 !important;\n}\n\n.trafico-recoger-filter__option {\n  font-size: 12px;\n}\n\n.trafico-recoger-filter-option-label,\n.trafico-recoger-filter-placeholder {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.trafico-recoger-filter-option-label {\n  justify-content: space-between;\n  width: 100%;\n}\n\n.trafico-recoger-filter-option-label > span:first-child {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.trafico-recoger-delay-summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  color: #71839b;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.trafico-recoger-delay-summary > span:first-child {\n  margin-right: 2px;\n}\n\n.trafico-recoger-filter-count-badge {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 20px;\n  box-sizing: border-box;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #e4eef7;\n  color: #305274;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.trafico-recoger-filter-count-badge.is-delay-yellow {\n  background: #fff0b8;\n  color: #806500;\n}\n\n.trafico-recoger-filter-count-badge.is-delay-normal {\n  border: 1px solid #d7e1ec;\n  background: #fff;\n  color: #71839b;\n}\n\n.trafico-recoger-filter-count-badge.is-delay-orange {\n  background: rgba(224, 160, 25, 0.24);\n  color: #8a5b00;\n}\n\n.trafico-recoger-filter-count-badge.is-delay-red {\n  background: var(--solicitudes-filter-red) !important;\n  color: #fff !important;\n  opacity: 1 !important;\n}\n\n.trafico-recoger-filter__option .trafico-recoger-filter-count-badge.is-delay-red,\n.trafico-recoger-filter__option--is-focused .trafico-recoger-filter-count-badge.is-delay-red,\n.trafico-recoger-filter__option--is-selected .trafico-recoger-filter-count-badge.is-delay-red {\n  display: inline-flex !important;\n  flex: 0 0 22px !important;\n  width: 22px !important;\n  height: 20px !important;\n  min-width: 22px !important;\n  padding: 0 6px !important;\n  border-radius: 999px !important;\n  background-color: #f39a97 !important;\n  color: #6f1f1b !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.trafico-recoger-refresh,\n.trafico-recoger-view-switch button {\n  min-height: 38px;\n  border: 1px solid #d7e1ec;\n  background: #fff;\n  color: #305274;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.trafico-recoger-refresh {\n  border-radius: 8px;\n  padding: 0 13px;\n}\n\n.trafico-recoger-refresh i {\n  margin-right: 5px;\n}\n\n.trafico-recoger-refresh:disabled {\n  cursor: wait;\n  opacity: 0.6;\n}\n\n.trafico-recoger-view-switch {\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.trafico-recoger-view-switch button {\n  border-width: 1px 0 1px 1px;\n  padding: 0 13px;\n}\n\n.trafico-recoger-view-switch button:last-child {\n  border-right-width: 1px;\n}\n\n.trafico-recoger-view-switch button.is-active {\n  background: #006699;\n  border-color: #006699;\n  color: #fff;\n}\n\n.trafico-recoger-toolbar {\n  margin-bottom: 14px;\n}\n\n.trafico-recoger-toolbar label {\n  width: min(100%, 520px);\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #d7e1ec;\n  border-radius: 8px;\n  background: #fff;\n  color: #7c8fa6;\n}\n\n.trafico-recoger-toolbar input {\n  width: 100%;\n  height: 40px;\n  border: 0;\n  outline: 0;\n  color: #243b53;\n}\n\n.trafico-recoger-actions > label input {\n  width: 100%;\n  height: 38px;\n  border: 0;\n  outline: 0;\n  color: #243b53;\n}\n\n.trafico-recoger-table-card,\n.trafico-recoger-map-card {\n  overflow: hidden;\n  border: 1px solid #e1e8f0;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 16px rgba(32, 65, 97, 0.05);\n}\n\n.trafico-recoger-mobile-list {\n  display: none;\n}\n\n.trafico-recoger-table-scroll {\n  height: calc(100dvh - 220px);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.trafico-recoger-table {\n  margin: 0;\n  color: #364f6b;\n  font-size: 12px;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n/* Distribución fija para mantener todos los campos visibles sin scroll horizontal. */\n.trafico-recoger-table th:nth-child(1),\n.trafico-recoger-table td:nth-child(1) {\n  width: 13% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(2),\n.trafico-recoger-table td:nth-child(2) {\n  width: 8% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(3),\n.trafico-recoger-table td:nth-child(3) {\n  width: 11% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(4),\n.trafico-recoger-table td:nth-child(4) {\n  width: 17% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(5),\n.trafico-recoger-table td:nth-child(5) {\n  width: 19% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(6),\n.trafico-recoger-table td:nth-child(6) {\n  width: 10% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(7),\n.trafico-recoger-table td:nth-child(7) {\n  width: 9% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(8),\n.trafico-recoger-table td:nth-child(8) {\n  width: 7% !important;\n  min-width: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(9),\n.trafico-recoger-table td:nth-child(9) {\n  width: 6% !important;\n  min-width: 64px !important;\n  text-align: center;\n}\n\n.trafico-recoger-table th:nth-child(1),\n.trafico-recoger-table td:nth-child(1) {\n  left: 0 !important;\n}\n\n.trafico-recoger-table th:nth-child(2),\n.trafico-recoger-table td:nth-child(2) {\n  left: auto !important;\n}\n\n/* Esta tabla no necesita columnas congeladas; evita el espacio visual entre Empresa y Agencia. */\n.trafico-recoger-table tbody td:nth-child(-n + 2) {\n  position: static !important;\n  left: auto !important;\n  box-shadow: none !important;\n}\n\n.trafico-recoger-table th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #006699;\n  white-space: nowrap !important;\n  overflow: hidden;\n  text-overflow: clip;\n  line-height: 1.15;\n  font-size: 12px;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.trafico-recoger-table thead th,\n.trafico-recoger-table thead th * {\n  color: #fff !important;\n}\n\n.trafico-recoger-sort-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  text-transform: inherit;\n}\n\n.trafico-recoger-sort-button i {\n  flex: 0 0 auto;\n  font-size: 13px;\n  opacity: 0.7;\n}\n\n.trafico-recoger-sort-button.is-active i {\n  opacity: 1;\n}\n\n.trafico-recoger-sort-button:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.trafico-recoger-table td {\n  padding: 5px;\n  vertical-align: middle;\n  max-width: 0;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  line-height: 1.35;\n}\n\n.trafico-recoger-table strong {\n  color: #000;\n}\n\n.trafico-recoger-table tbody td {\n  color: #000;\n}\n\n/* El contenedor usa text-nowrap por compatibilidad con otras tablas, pero\n * la novedad debe ocupar varias líneas dentro de su propia columna. */\n.trafico-recoger-table tbody td:nth-child(5),\n.trafico-recoger-table thead th:nth-child(5) {\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.trafico-recoger-table tbody tr {\n  background: #fff;\n  cursor: default;\n}\n\n.trafico-recoger-novelty-trigger {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.trafico-recoger-novelty-trigger:hover,\n.trafico-recoger-novelty-trigger:focus-visible {\n  color: #1769aa;\n  text-decoration: underline;\n}\n\n.trafico-recoger-refuerzo-badge {\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.trafico-recoger-table tbody tr.is-selected,\n.trafico-recoger-table tbody tr:hover {\n  background: #edf7ff;\n}\n\n.trafico-recoger-table tbody tr.is-delay-yellow {\n  background: #fff8d8;\n}\n\n.trafico-recoger-table tbody tr.is-delay-orange {\n  background: rgba(224, 160, 25, 0.16);\n}\n\n.trafico-recoger-table tbody tr.is-delay-red {\n  background: var(--solicitudes-filter-red);\n}\n\n.trafico-recoger-table tbody tr.is-delay-yellow:hover,\n.trafico-recoger-table tbody tr.is-delay-yellow.is-selected {\n  background: #fff0b8;\n}\n\n.trafico-recoger-table tbody tr.is-delay-orange:hover,\n.trafico-recoger-table tbody tr.is-delay-orange.is-selected {\n  background: rgba(224, 160, 25, 0.28);\n}\n\n.trafico-recoger-table tbody tr.is-delay-red:hover,\n.trafico-recoger-table tbody tr.is-delay-red.is-selected {\n  background: var(--solicitudes-filter-red);\n}\n\n/* Bootstrap aplica el fondo directamente sobre los td en desktop; por eso\n * el estado de retraso también debe pintar cada celda de la fila. */\n.trafico-recoger-table tbody tr.is-delay-yellow > td {\n  background-color: #fff8d8 !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-orange > td {\n  background-color: color-mix(in srgb, #e0a019 16%, white) !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-red > td {\n  background-color: var(--solicitudes-filter-red) !important;\n  color: #6f1f1b !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-yellow:hover > td,\n.trafico-recoger-table tbody tr.is-delay-yellow.is-selected > td {\n  background-color: #fff0b8 !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-orange:hover > td,\n.trafico-recoger-table tbody tr.is-delay-orange.is-selected > td {\n  background-color: color-mix(in srgb, #e0a019 28%, white) !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-red:hover > td,\n.trafico-recoger-table tbody tr.is-delay-red.is-selected > td {\n  background-color: var(--solicitudes-filter-red) !important;\n}\n\n.trafico-recoger-table tbody tr.is-delay-red > td strong {\n  color: #6f1f1b !important;\n}\n\n.trafico-recoger-actions-cell {\n  display: table-cell !important;\n  vertical-align: middle;\n  white-space: nowrap !important;\n  text-align: center;\n  position: relative !important;\n  z-index: 1 !important;\n}\n\n.trafico-recoger-actions-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.trafico-recoger-page .custom-tooltip {\n  z-index: 20000;\n}\n\n.trafico-recoger-page .custom-tooltip::after {\n  z-index: 20001;\n}\n\n.trafico-recoger-copy-button,\n.trafico-recoger-contract-copy-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #cbd8e5;\n  border-radius: 6px;\n  background: #fff;\n  color: #35627f;\n  cursor: pointer;\n  font-size: 17px;\n  line-height: 1;\n}\n\n.trafico-recoger-copy-button:hover,\n.trafico-recoger-contract-copy-button:hover {\n  border-color: #006699;\n  background: #edf7ff;\n  color: #006699;\n}\n\n.trafico-recoger-available-button {\n  color: #006699;\n}\n\n.trafico-recoger-available-button:hover {\n  border-color: #006699;\n  background: #edf7ff;\n  color: #005580;\n}\n\n/* La clase histórica de columnas congeladas eleva la fila al interactuar\n * con un tooltip. En esta vista las acciones deben permanecer dentro de su\n * fila y nunca cubrir el encabezado sticky. */\n.trafico-recoger-table thead th {\n  z-index: 20 !important;\n}\n\n.trafico-recoger-table tbody tr:has(.custom-tooltip:hover),\n.trafico-recoger-table tbody tr:has(.custom-tooltip:focus-within) {\n  z-index: 1 !important;\n}\n\n/* Ajustes propios de la pantalla; el navbar y el drawer los controla\n * traficoResponsive.css mediante body.trafico-responsive-page. */\n@media (max-width: 1199px) {\n  .trafico-recoger-page .content-wrapper,\n  .trafico-recoger-page .container-fluid {\n    min-width: 0;\n  }\n}\n\n.trafico-recoger-empty,\n.trafico-recoger-state {\n  padding: 42px 20px;\n  text-align: center;\n  color: #71839b;\n}\n\n.trafico-recoger-state-error {\n  color: #b42318;\n}\n\n.trafico-recoger-map-card {\n  width: 100%;\n  max-width: 100%;\n  height: calc(100dvh - 210px);\n  padding: 12px;\n}\n\n.trafico-recoger-map {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 9px;\n  background: #e9f0f6;\n}\n\n.trafico-recoger-map-layout {\n  position: relative;\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  height: 100%;\n  border-radius: 9px;\n}\n\n.trafico-recoger-map-fullscreen-button {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid rgba(215, 225, 236, 0.95);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #305274;\n  box-shadow: 0 3px 10px rgba(28, 58, 86, 0.18);\n  cursor: pointer;\n  font-size: 21px;\n}\n\n.trafico-recoger-map-fullscreen-button:hover,\n.trafico-recoger-map-fullscreen-button:focus-visible {\n  background: #006699;\n  color: #fff;\n  outline: none;\n}\n\n.trafico-recoger-contract-list {\n  position: absolute;\n  top: 60px;\n  left: 10px;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  width: 270px;\n  min-width: 0;\n  max-width: calc(100% - 20px);\n  height: calc(100% - 90px);\n  max-height: calc(100% - 90px);\n  overflow: hidden;\n  border: 1px solid #d3deea;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(28, 58, 86, 0.2);\n  transition: width 220ms ease, height 260ms ease;\n}\n\n.trafico-recoger-map-type-controls {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 6;\n  display: flex;\n  align-items: stretch;\n  width: 270px;\n  min-width: 0;\n  max-width: calc(100% - 20px);\n  height: 40px;\n  padding: 0;\n  background: #fff;\n  border: 1px solid rgba(215, 225, 236, 0.95);\n  border-radius: 5px;\n  box-shadow: 0 2px 8px rgba(28, 58, 86, 0.16);\n  overflow: hidden;\n}\n\n.trafico-recoger-map-type-controls button {\n  flex: 0 0 auto;\n  min-width: 0;\n  height: 100%;\n  padding: 0 14px;\n  border: 0;\n  border-right: 1px solid #e2e8ee;\n  background: #fff;\n  color: #526d8f;\n  cursor: pointer;\n  font: 13px Arial, sans-serif;\n  white-space: nowrap;\n}\n\n.trafico-recoger-map-type-controls button:first-child {\n  flex: 0 0 78px;\n  width: 78px;\n  border-radius: 2px 0 0 2px;\n}\n\n.trafico-recoger-map-type-controls button:nth-child(2) {\n  flex: 0 0 96px;\n  width: 96px;\n}\n\n.trafico-recoger-map-type-controls button:last-child {\n  flex: 0 0 96px;\n  width: 96px;\n  padding-right: 4px;\n  padding-left: 4px;\n  border-right: 0;\n  border-radius: 0 2px 2px 0;\n  font-size: 12px;\n}\n\n.trafico-recoger-map-type-controls button.is-active {\n  position: relative;\n  z-index: 1;\n  background: #f7f9fb;\n  color: #173961;\n  font-weight: 700;\n}\n\n.trafico-recoger-contract-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 45px;\n  padding: 12px 14px;\n  width: 100%;\n  height: 45px;\n  min-height: 45px;\n  box-sizing: border-box;\n  border: 0;\n  background: #006699;\n  color: #fff;\n  cursor: pointer;\n  font: inherit;\n  overflow: hidden;\n  text-align: left;\n}\n\n.trafico-recoger-contract-list-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.trafico-recoger-contract-list-header strong,\n.trafico-recoger-contract-list-header span {\n  color: #fff;\n  font-size: 14px;\n}\n\n.trafico-recoger-contract-list-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  margin-left: 8px;\n  padding: 0;\n  box-sizing: border-box;\n  border: 0;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.16);\n  color: #fff;\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.trafico-recoger-contract-list-toggle:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.trafico-recoger-contract-list-scroll {\n  display: grid;\n  flex: 1 1 auto;\n  gap: 8px;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px;\n  background: #f7f9fb;\n  transition: max-height 260ms ease, opacity 180ms ease, padding 260ms ease;\n  max-height: 1200px;\n}\n\n.trafico-recoger-contract-item {\n  display: grid;\n  gap: 6px;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 10px;\n  border: 1px solid #dbe5ee;\n  border-left: 6px solid #a7bed2;\n  border-radius: 8px;\n  background: #fff;\n  color: #000;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  box-shadow: 0 2px 8px rgba(28, 58, 86, 0.12);\n  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.trafico-recoger-contract-item.is-delay-yellow {\n  border-left-color: #e2b93b;\n  background: #fff8d8;\n}\n\n.trafico-recoger-contract-item.is-delay-orange {\n  border-left-color: #e0a019;\n  background: rgba(224, 160, 25, 0.16);\n}\n\n.trafico-recoger-contract-item.is-delay-red {\n  border-left-color: var(--solicitudes-filter-red);\n  background: var(--solicitudes-filter-red);\n  color: #6f1f1b;\n}\n\n.trafico-recoger-contract-item:hover,\n.trafico-recoger-contract-item.is-selected {\n  border-left-color: #006699;\n  background: #edf7ff;\n}\n\n.trafico-recoger-contract-item.is-delay-red:hover,\n.trafico-recoger-contract-item.is-delay-red.is-selected {\n  border-left-color: var(--solicitudes-filter-red);\n  background: var(--solicitudes-filter-red);\n  color: #6f1f1b;\n}\n\n.trafico-recoger-contract-item.is-delay-yellow,\n.trafico-recoger-contract-item.is-delay-orange,\n.trafico-recoger-contract-item.is-delay-red {\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-right-color: rgba(255, 255, 255, 0.8);\n  border-bottom-color: rgba(255, 255, 255, 0.8);\n}\n\n.trafico-recoger-contract-item.is-delay-yellow:hover,\n.trafico-recoger-contract-item.is-delay-orange:hover,\n.trafico-recoger-contract-item.is-delay-red:hover {\n  box-shadow: 0 4px 12px rgba(28, 58, 86, 0.2);\n}\n\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-title > strong,\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-plate,\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-row,\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-row b,\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-speed,\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-contract-item-footer {\n  color: #6f1f1b !important;\n}\n\n.trafico-recoger-contract-item-heading,\n.trafico-recoger-contract-item-row,\n.trafico-recoger-contract-item-footer {\n  display: grid;\n  min-width: 0;\n}\n\n.trafico-recoger-contract-item-heading {\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 8px;\n  min-width: 0;\n}\n\n.trafico-recoger-contract-item-heading-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  overflow: visible;\n}\n\n.trafico-recoger-contract-copy-button {\n  width: 26px;\n  height: 26px;\n  border: 0;\n  background: #edf3f8;\n  color: #58758f;\n  font-size: 15px;\n}\n\n.trafico-recoger-contract-copy-button:hover {\n  background: #dcecf7;\n}\n\n.trafico-recoger-contract-item-title {\n  display: grid;\n  gap: 5px;\n  min-width: 0;\n}\n\n.trafico-recoger-contract-item-title > strong {\n  color: #193856;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.trafico-recoger-contract-item-plate {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #edf3f8;\n  color: #5d7893 !important;\n  font-size: 12px !important;\n  font-weight: 700;\n}\n\n.trafico-recoger-contract-item-plate i {\n  color: #476985;\n  font-size: 14px;\n}\n\n.trafico-recoger-contract-item-chevron {\n  color: #58758f;\n  font-size: 32px;\n  line-height: 1;\n}\n\n.trafico-recoger-contract-item-row {\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 6px;\n}\n\n.trafico-recoger-contract-item-row > i,\n.trafico-recoger-contract-item-speed > i {\n  color: #4e6e89;\n  font-size: 16px;\n  text-align: center;\n}\n\n.trafico-recoger-contract-item-row > span {\n  overflow: hidden;\n  color: #45627d;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.trafico-recoger-contract-item-row > span b {\n  color: #34516d;\n}\n\n.trafico-recoger-contract-item-speed {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  border-top: 1px solid #e2eaf1;\n  padding-top: 6px;\n  color: #4e6e89;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.trafico-recoger-contract-item-footer {\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  border-top: 1px solid #edf1f5;\n  padding-top: 6px;\n}\n\n.trafico-recoger-contract-item-icons {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  color: #36a852;\n  font-size: 18px;\n}\n\n.trafico-recoger-contract-item-time-values {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n}\n\n.trafico-recoger-contract-item-last-report {\n  overflow: hidden;\n  color: #66809a;\n  font-size: 11px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.trafico-recoger-uninstall-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  max-width: 100%;\n  min-height: 24px;\n  padding: 4px 8px;\n  border: 1px solid rgba(81, 111, 137, .16);\n  border-radius: 999px;\n  background: #edf3f8;\n  color: #45627d;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.trafico-recoger-uninstall-badge i {\n  font-size: 13px;\n}\n\n.trafico-recoger-uninstall-badge strong {\n  font-size: 10px;\n}\n\n.trafico-recoger-uninstall-badge.is-delay-yellow {\n  border-color: #ead58a;\n  background: #fff0b8;\n  color: #806500;\n}\n\n.trafico-recoger-uninstall-badge.is-delay-orange {\n  border-color: #e0a019;\n  background: #f3c28f;\n  color: #754b00;\n}\n\n.trafico-recoger-uninstall-badge.is-delay-red {\n  border-color: #e02b29;\n  background: #f39a97;\n  color: #6f1f1b;\n}\n\n.trafico-recoger-contract-item.is-delay-red .trafico-recoger-uninstall-badge {\n  border-color: rgba(111, 31, 27, .28);\n}\n\n.trafico-recoger-contract-item-heading > strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.trafico-recoger-contract-list-empty {\n  margin: 12px 6px;\n  color: #71839b;\n  font-size: 12px;\n  text-align: center;\n}\n\n.trafico-recoger-contract-list.is-collapsed {\n  width: 160px;\n  min-width: 160px;\n  height: 45px;\n  max-height: 45px;\n}\n\n.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-header {\n  height: 45px;\n  min-height: 45px;\n  flex-basis: 45px;\n  justify-content: center;\n  padding: 8px;\n}\n\n.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-scroll {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.trafico-recoger-contract-list.is-collapsed .trafico-recoger-contract-list-toggle {\n  margin-left: 0;\n}\n\n.trafico-recoger-map-summary {\n  margin: 10px 2px 0;\n  color: #71839b;\n  font-size: 12px;\n}\n\n.trafico-recoger-map-info {\n  display: grid;\n  gap: 3px;\n  width: min(330px, 72vw);\n  max-width: 330px;\n  min-width: 220px;\n  margin: 0 auto;\n  max-height: none;\n  overflow: visible;\n  padding: 2px;\n  color: #304a65;\n  font-size: 12px;\n}\n\n/* Google Maps crea un scroll propio en el contenedor del InfoWindow. Para\n   este popup se desactiva y se conserva únicamente el scroll del historial. */\n.gm-style-iw-c:has(.trafico-recoger-map-info),\n.gm-style-iw-d:has(.trafico-recoger-map-info),\n.gm-style-iw:has(.trafico-recoger-map-info) {\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.gm-style-iw-c:has(.trafico-recoger-map-info) {\n  width: min(370px, calc(100vw - 40px)) !important;\n  max-width: calc(100vw - 40px) !important;\n  box-sizing: border-box !important;\n  padding: 14px !important;\n}\n\n.gm-style-iw-d:has(.trafico-recoger-map-info) {\n  width: 100% !important;\n  box-sizing: border-box !important;\n  padding: 0 !important;\n}\n\n.trafico-recoger-map-info {\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.trafico-recoger-map-info strong {\n  color: #173961;\n}\n\n.trafico-recoger-map-info-heading {\n  margin-top: 6px;\n  border-top: 1px solid #dbe5ee;\n  padding-top: 6px;\n}\n\n.trafico-recoger-map-info-chat {\n  display: grid;\n  gap: 6px;\n  max-height: 190px;\n  overflow-y: auto;\n  padding-right: 3px;\n}\n\n.trafico-recoger-map-info-message {\n  padding: 6px 7px;\n  border-left: 3px solid #006699;\n  border-radius: 5px;\n  background: #f3f7fa;\n}\n\n.trafico-recoger-map-info-message-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 3px;\n}\n\n.trafico-recoger-map-info-message-meta strong {\n  color: #34516d;\n  font-size: 11px;\n}\n\n.trafico-recoger-map-info-message-meta time {\n  color: #71839b;\n  font-size: 10px;\n  white-space: nowrap;\n}\n\n.trafico-recoger-map-info-message p {\n  margin: 0;\n  color: #243b53;\n  font-size: 11px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.trafico-recoger-map-info-form {\n  display: grid;\n  gap: 5px;\n  margin-top: 7px;\n  border-top: 1px solid #dbe5ee;\n  padding-top: 7px;\n}\n\n.trafico-recoger-map-info-form textarea {\n  width: 100%;\n  resize: vertical;\n  border: 1px solid #cbd8e5;\n  border-radius: 5px;\n  padding: 5px 7px;\n  color: #243b53;\n  font: inherit;\n  font-size: 11px;\n  outline: 0;\n}\n\n.trafico-recoger-map-info-form textarea:focus {\n  border-color: #006699;\n  box-shadow: 0 0 0 2px rgba(0, 102, 153, 0.12);\n}\n\n.trafico-recoger-map-info-form-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.trafico-recoger-map-info-form button {\n  min-height: 26px;\n  border: 0;\n  border-radius: 5px;\n  padding: 0 10px;\n  background: #006699;\n  color: #fff;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.trafico-recoger-map-info-form button:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n\n.trafico-recoger-novedades-modal {\n  max-width: 420px;\n}\n\n.trafico-recoger-novedades-modal .modal-content {\n  overflow: hidden;\n  border: 1px solid #d7e1ec;\n  border-radius: 10px;\n}\n\n.trafico-recoger-novedades-modal .modal-header {\n  position: relative !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  padding: 12px 16px;\n  background: #006699;\n  color: #fff;\n  overflow: visible !important;\n  pointer-events: auto !important;\n}\n\n.trafico-recoger-novedades-modal .modal-title,\n.trafico-recoger-novedades-modal .modal-header .btn-close {\n  color: #fff;\n}\n\n.trafico-recoger-novedades-modal .modal-title {\n  margin: 0 !important;\n  padding: 0 !important;\n  color: #fff !important;\n  font-size: 20px;\n  line-height: 1.25;\n}\n\n.trafico-recoger-novedades-modal .modal-header .btn-close {\n  position: static !important;\n  display: grid !important;\n  flex: 0 0 32px;\n  width: 32px !important;\n  height: 32px !important;\n  margin: 0 0 0 auto !important;\n  padding: 0;\n  border: 1px solid #d0dbe8;\n  border-radius: 50%;\n  background-color: #edf2f8;\n  background-size: 14px;\n  filter: none;\n  opacity: 1;\n}\n\n.trafico-recoger-novedades-modal .modal-header .btn-close:hover,\n.trafico-recoger-novedades-modal .modal-header .btn-close:focus {\n  background-color: #fff;\n  opacity: 1;\n}\n\n/* ModalBaseSm aplica esta clase al dialog; estas reglas ganan a los estilos\n   generales de ResponsiveModalSheets en pantallas pequeñas. */\n.modal .trafico-recoger-novedades-modal > .modal-content > .modal-header {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  pointer-events: auto !important;\n  overflow: visible !important;\n}\n\n.modal .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {\n  position: static !important;\n  inset: auto !important;\n  align-self: center !important;\n  transform: none !important;\n  top: auto !important;\n  right: auto !important;\n  display: grid !important;\n  flex: 0 0 32px !important;\n  width: 32px !important;\n  height: 32px !important;\n  margin: 0 0 0 auto !important;\n  padding: 0 !important;\n  border: 1px solid #d0dbe8 !important;\n  border-radius: 50% !important;\n  background-color: #edf2f8 !important;\n  filter: none !important;\n  opacity: 1 !important;\n}\n\n.trafico-recoger-novedades-modal .modal-body {\n  max-height: min(80dvh, 650px);\n  overflow: hidden;\n  padding: 14px 16px 16px;\n  color: #243b53;\n}\n\n.trafico-recoger-novedades-content {\n  display: grid;\n  gap: 12px;\n}\n\n.trafico-recoger-novedades-list {\n  display: grid;\n  gap: 8px;\n  max-height: min(320px, 45dvh);\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.trafico-recoger-novedad {\n  padding: 9px 10px;\n  border: 1px solid #dbe5ee;\n  border-left: 4px solid #006699;\n  border-radius: 7px;\n  background: #f7f9fb;\n}\n\n.trafico-recoger-novedad-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 5px;\n}\n\n.trafico-recoger-novedad-meta strong {\n  color: #34516d;\n  font-size: 12px;\n}\n\n.trafico-recoger-novedad p {\n  margin: 0;\n  color: #243b53;\n  font-size: 13px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.trafico-recoger-novedad time {\n  display: block;\n  color: #71839b;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.trafico-recoger-novedades-message,\n.trafico-recoger-novedades-error {\n  margin: 0;\n  font-size: 13px;\n}\n\n.trafico-recoger-novedades-message {\n  color: #71839b;\n}\n\n.trafico-recoger-novedades-error {\n  color: #b42318;\n}\n\n.trafico-recoger-novedades-sync-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  color: #1769aa;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.trafico-recoger-novedad-form {\n  display: grid;\n  gap: 7px;\n  border-top: 1px solid #e1e8f0;\n  padding-top: 12px;\n}\n\n.trafico-recoger-novedad-form label {\n  color: #243b53;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.trafico-recoger-novedad-form textarea {\n  width: 100%;\n  resize: vertical;\n  border: 1px solid #cbd8e5;\n  border-radius: 6px;\n  padding: 8px 10px;\n  color: #243b53;\n  font: inherit;\n  font-size: 13px;\n  outline: 0;\n}\n\n.trafico-recoger-novedad-form textarea:focus {\n  border-color: #006699;\n  box-shadow: 0 0 0 2px rgba(0, 102, 153, 0.12);\n}\n\n.trafico-recoger-novedad-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.trafico-recoger-novedad-form button {\n  min-height: 34px;\n  border: 0;\n  border-radius: 6px;\n  padding: 0 13px;\n  background: #006699;\n  color: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.trafico-recoger-novedad-form .trafico-recoger-novedad-cancel {\n  border: 1px solid #cbd8e5;\n  background: #fff;\n  color: #45627d;\n}\n\n.trafico-recoger-novedad-form .trafico-recoger-novedad-cancel:hover:not(:disabled) {\n  background: #f3f7fa;\n}\n\n.trafico-recoger-novedad-form button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n@media (max-width: 768px) {\n  body.trafico-recoger-no-scroll {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .trafico-recoger-page,\n  .trafico-recoger-content {\n    height: auto;\n    min-height: 100dvh;\n    overflow: visible;\n  }\n\n  .trafico-recoger-page {\n    padding-bottom: calc(70px + env(safe-area-inset-bottom));\n  }\n\n  .trafico-recoger-content {\n    min-height: calc(100dvh - 70px);\n    padding-bottom: calc(86px + env(safe-area-inset-bottom)) !important;\n  }\n\n  .trafico-recoger-table-scroll {\n    height: auto;\n    width: 100% !important;\n    max-width: 100%;\n  }\n\n  /* En móvil se usa la tarjeta responsive, como en la vista Tráfico. */\n  .trafico-recoger-page .trafico-recoger-table-card {\n    display: none !important;\n  }\n\n  .trafico-recoger-mobile-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  .trafico-recoger-mobile-card {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    padding: 16px;\n    border: 1px solid #dce6ef;\n    border-left: 5px solid #9bb8ce;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(37, 61, 86, 0.08);\n    color: #304f6e;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(37, 61, 86, 0.12);\n    transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n  }\n\n  .trafico-recoger-mobile-card.is-selected,\n  .trafico-recoger-mobile-card:active {\n    border-left-color: #006699;\n    background: #edf7ff;\n  }\n\n  .trafico-recoger-mobile-card.is-delay-yellow {\n    border-color: #ead58a;\n    background: #fff8d8;\n  }\n\n  .trafico-recoger-mobile-card.is-delay-orange {\n    border-color: #e0a019;\n    background: rgba(224, 160, 25, 0.16);\n  }\n\n  .trafico-recoger-mobile-card.is-delay-red {\n    border-color: var(--solicitudes-filter-red);\n    background: var(--solicitudes-filter-red);\n    color: #6f1f1b;\n  }\n\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-header strong,\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-header span,\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-label,\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-card-novelty span,\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-time-label,\n  .trafico-recoger-mobile-card.is-delay-red .trafico-recoger-mobile-time-metric strong {\n    color: #6f1f1b !important;\n  }\n\n  .trafico-recoger-mobile-card-header,\n  .trafico-recoger-mobile-card-footer {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .trafico-recoger-mobile-card-header > div:first-child {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    gap: 3px;\n  }\n\n  .trafico-recoger-mobile-card-header strong {\n    color: #173961;\n    font-size: 15px;\n    line-height: 1.25;\n    overflow-wrap: anywhere;\n  }\n\n  .trafico-recoger-mobile-card-header span,\n  .trafico-recoger-mobile-card-footer {\n    color: #71839b;\n    font-size: 13px;\n  }\n\n  .trafico-recoger-mobile-card-actions {\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .trafico-recoger-mobile-card-actions .trafico-recoger-copy-button {\n    width: 36px;\n    height: 36px;\n  }\n\n  .trafico-recoger-mobile-card-device,\n  .trafico-recoger-mobile-card-footer span {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n  }\n\n  .trafico-recoger-mobile-card-device {\n    padding: 9px 10px;\n    border-radius: 9px;\n    background: #eef5fa;\n    color: #456b89;\n    font-size: 14px;\n  }\n\n  .trafico-recoger-mobile-card-device i,\n  .trafico-recoger-mobile-card-footer i {\n    color: #006699;\n    font-size: 18px;\n  }\n\n  .trafico-recoger-mobile-time-metric {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n    gap: 8px;\n  }\n\n  .trafico-recoger-mobile-time-metric > div {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    gap: 2px;\n  }\n\n  .trafico-recoger-mobile-time-metric > i {\n    flex: 0 0 auto;\n    color: #006699;\n    font-size: 19px;\n  }\n\n  .trafico-recoger-mobile-time-label {\n    display: block !important;\n    color: #71839b;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: .03em;\n    line-height: 1.15;\n    text-transform: uppercase;\n  }\n\n  .trafico-recoger-mobile-time-metric strong {\n    display: block;\n    color: #304f6e;\n    font-size: 13px;\n    line-height: 1.2;\n    overflow-wrap: anywhere;\n  }\n\n  .trafico-recoger-mobile-card-grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 0.8fr);\n    gap: 12px;\n  }\n\n  .trafico-recoger-mobile-card-grid > div,\n  .trafico-recoger-mobile-card-novelty {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    gap: 3px;\n    font-size: 13px;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n  }\n\n  .trafico-recoger-mobile-label {\n    color: #71839b;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: .04em;\n    text-transform: uppercase;\n  }\n\n  .trafico-recoger-mobile-card-novelty {\n    padding-top: 10px;\n    border-top: 1px solid #e0e9f1;\n  }\n\n  button.trafico-recoger-mobile-card-novelty {\n    width: 100%;\n    padding-right: 0;\n    padding-left: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  button.trafico-recoger-mobile-card-novelty:hover,\n  button.trafico-recoger-mobile-card-novelty:focus-visible {\n    color: #1769aa;\n  }\n\n  .trafico-recoger-mobile-card-footer {\n    padding-top: 10px;\n    border-top: 1px solid #e0e9f1;\n  }\n\n  .trafico-recoger-mobile-card-footer > i {\n    font-size: 22px;\n  }\n\n  .trafico-recoger-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .trafico-recoger-actions {\n    justify-content: flex-start;\n    gap: 8px;\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .trafico-recoger-actions > label {\n    box-sizing: border-box;\n    min-height: 52px;\n    width: 100%;\n    order: -1;\n    border-color: #dce5ef;\n    border-radius: 14px;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);\n    padding: 0 14px;\n  }\n\n  .trafico-recoger-actions > label i {\n    font-size: 20px;\n  }\n\n  .trafico-recoger-actions > label input {\n    height: 50px;\n    min-width: 0;\n    font-size: 16px;\n  }\n\n  .trafico-recoger-actions > label input::placeholder {\n    color: #9aabbc;\n  }\n\n  .trafico-recoger-filter-select {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .trafico-recoger-filter__control {\n    height: 52px !important;\n    min-height: 52px !important;\n    border-color: #dce5ef !important;\n    border-radius: 14px !important;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06) !important;\n  }\n\n  .trafico-recoger-filter__value-container,\n  .trafico-recoger-filter__indicators {\n    min-height: 50px;\n  }\n\n  .trafico-recoger-filter__placeholder {\n    color: #9aabbc;\n    font-size: 16px;\n  }\n\n  .trafico-recoger-refresh,\n  .trafico-recoger-view-switch button {\n    min-height: 52px;\n    border-radius: 14px;\n  }\n\n  .trafico-recoger-table thead {\n    display: none;\n  }\n\n  .trafico-recoger-table,\n  .trafico-recoger-table tbody,\n  .trafico-recoger-table tr,\n  .trafico-recoger-table td {\n    display: block;\n    width: 100%;\n    min-width: 0 !important;\n  }\n\n  .trafico-recoger-table tbody tr {\n    padding: 12px 14px;\n    border-bottom: 1px solid #e8eef4;\n  }\n\n  .trafico-recoger-table td {\n    position: static !important;\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 5px 0;\n    white-space: normal;\n    text-align: right;\n  }\n\n  .trafico-recoger-table td.trafico-recoger-actions-cell {\n    display: table-cell !important;\n    justify-content: center;\n  }\n\n  .trafico-recoger-table td.trafico-recoger-actions-cell::before {\n    display: none;\n  }\n\n  .trafico-recoger-table td::before {\n    color: #71839b;\n    content: attr(data-label);\n    font-weight: 600;\n    text-align: left;\n  }\n\n  .trafico-recoger-map {\n    height: 55dvh;\n    min-height: 55dvh;\n  }\n\n  .trafico-recoger-map-card {\n    width: 100%;\n    height: auto;\n    margin-bottom: 12px;\n  }\n\n  .trafico-recoger-table-card {\n    margin-bottom: 12px;\n  }\n\n  .trafico-recoger-map-layout {\n    height: 55dvh;\n    overflow: hidden;\n  }\n\n  .trafico-recoger-map-fullscreen-button {\n    top: 10px;\n    right: 10px;\n  }\n\n  .trafico-recoger-map-type-controls {\n    left: 10px;\n    width: min(270px, calc(100% - 20px));\n    min-width: 0;\n    max-width: calc(100% - 20px);\n  }\n\n  .trafico-recoger-contract-list {\n    top: auto;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    min-width: 0;\n    height: 220px;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .trafico-recoger-contract-list.is-collapsed {\n    width: 100%;\n    min-width: 0;\n    height: 48px;\n    max-height: 48px;\n  }\n\n  .trafico-recoger-contract-list-scroll {\n    height: auto;\n  }\n}\n\n/* El modal de novedades usa ModalBaseSm + ResponsiveModalSheets. En móvil\n * se mantiene el bottom sheet parcial, el header global con handle/X y un\n * solo scroll para la lista del chat; el formulario queda siempre visible. */\n@media (max-width: 767px) {\n  .trafico-recoger-novedades-modal > .modal-content {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .trafico-recoger-novedades-modal > .modal-content > .modal-header {\n    position: sticky !important;\n    top: 0;\n    flex: 0 0 auto;\n    flex-direction: column !important;\n    align-items: stretch !important;\n    min-height: 26px;\n    padding: 8px 0 10px !important;\n    background: #006699;\n    color: #fff;\n    pointer-events: none !important;\n  }\n\n  .trafico-recoger-novedades-modal > .modal-content > .modal-header .modal-title {\n    display: block !important;\n    padding: 8px 56px 10px 18px;\n    color: #fff !important;\n    font-size: 18px;\n    text-align: left;\n  }\n\n  body.trafico-recoger-page .modal:not(.responsive-modal-sheet-expanded)\n    .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {\n    display: none !important;\n  }\n\n  body.trafico-recoger-page .modal.responsive-modal-sheet-expanded\n    .trafico-recoger-novedades-modal > .modal-content > .modal-header .btn-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    display: grid !important;\n    margin: 0 !important;\n    pointer-events: auto !important;\n  }\n\n  .trafico-recoger-novedades-modal > .modal-content > .modal-body {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    min-height: 0;\n    max-height: none;\n    overflow: hidden;\n    padding: 10px 14px 14px;\n  }\n\n  .trafico-recoger-novedades-content {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    min-height: 0;\n    gap: 10px;\n  }\n\n  .trafico-recoger-novedades-list {\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: none;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding-right: 3px;\n  }\n\n  .trafico-recoger-novedad-form {\n    flex: 0 0 auto;\n  }\n\n  .trafico-recoger-novedad-form textarea {\n    min-height: 76px;\n  }\n\n  .trafico-recoger-novedad-actions {\n    justify-content: flex-end;\n  }\n}\n\n/* El modal debe quedar por encima de las acciones de las tarjetas. Los\n * tooltips de esta página tienen z-index alto para la grilla y el mapa, por\n * eso el bottom sheet necesita una capa propia mientras está abierto. */\nbody .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal) {\n  z-index: 30000 !important;\n}\n\nbody.modal-open .trafico-recoger-page .custom-tooltip {\n  z-index: 1 !important;\n}\n\nbody.modal-open .trafico-recoger-page .custom-tooltip::after {\n  z-index: 2 !important;\n}\n\n@media (max-width: 767px) {\n  body .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal)\n    > .modal-dialog.trafico-recoger-novedades-modal\n    > .modal-content\n    > .modal-header {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: stretch !important;\n    min-height: 26px !important;\n    padding: 8px 0 10px !important;\n    background: #006699 !important;\n    color: #fff !important;\n    pointer-events: none !important;\n  }\n\n  body .modal.show:has(> .modal-dialog.trafico-recoger-novedades-modal)\n    > .modal-dialog.trafico-recoger-novedades-modal\n    > .modal-content\n    > .modal-header\n    > .modal-title {\n    display: block !important;\n    padding: 8px 56px 10px 18px !important;\n    color: #fff !important;\n    font-size: 18px !important;\n    line-height: 1.25;\n  }\n\n  body .modal.show:not(.responsive-modal-sheet-expanded):has(> .modal-dialog.trafico-recoger-novedades-modal)\n    .modal-header .btn-close {\n    display: none !important;\n  }\n\n  body .modal.show.responsive-modal-sheet-expanded:has(> .modal-dialog.trafico-recoger-novedades-modal)\n    .modal-header .btn-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    display: grid !important;\n    margin: 0 !important;\n    pointer-events: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
